const tracking = require('../../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/baggage_tracking').getInstance();
const baggageCollectionBuilder = require('../../../../../webapp/static-content/_versionedByRelease_/js/modules/builders/baggages').getInstance();
const TRACKING_SEGMENT_NAME = 'baggage-segment';
const TRACKING_OPTION_NAME = 'baggage-option';

const track = {
    common() {
        const primeInfo = this.getPrimeInfo();
        const {isPrimeView, isPrimeUser} = primeInfo;
        const {displayed: merchandisingDiscountDisplayed = false, discount: merchandisingDiscount = 0}
            = baggageCollectionBuilder.getMerchandisingDiscountInfo();
        const merchandisingDiscountPercentage = merchandisingDiscountDisplayed ? merchandisingDiscount : 0;
        return {
            auto: +this.doBaggageAllowAutoselection(),
            pax: this.getPaxCount(),
            prime: isPrimeView && isPrimeUser ? 'yes' : isPrimeView ? 'no' : 'na',
            maxdsc: tracking.getMaxdsc(primeInfo, merchandisingDiscountPercentage),
        };
    },
    click() {
        return Odigeo._.merge({
            name: TRACKING_SEGMENT_NAME,
            mes: '',
            sce: 'dc',
        }, track.common.call(this));
    },
    change() {
        return Odigeo._.merge({
            name: TRACKING_SEGMENT_NAME,
            sav: Math.floor(this.getPrimeSavedAmount()),
            sce: 'dc',
        }, track.common.call(this));
    },
    clickOption() {
        return Odigeo._.merge({
            name: TRACKING_OPTION_NAME,
            sav: Math.floor(this.getPrimeSavedAmount()),
            sel: this.model.get('selectedPieces'),
            sce: 'dc',
        }, track.common.call(this));
    },
    remove() {
        return Odigeo._.merge({
            name: TRACKING_SEGMENT_NAME,
            sav: Math.floor(this.getPrimeSavedAmount()),
        }, track.common.call(this));
    },
    close() {
        return Odigeo._.merge({
            name: TRACKING_OPTION_NAME,
        }, track.common.call(this));
    },
};

export default {
    onChange() {
        tracking.onChange(track.change.call(this));
    },
    onClick() {
        tracking.onClick(track.click.call(this));
    },
    onClickExtra() {
        tracking.onClickExtra(track.click.call(this));
    },
    onClickOption() {
        tracking.onClickOption(track.clickOption.call(this));
    },
    onRemove() {
        tracking.onRemove(track.remove.call(this));
    },
    onClose() {
        tracking.onClose(track.close.call(this));
    },
    onCloseSelector() {
        tracking.onCloseSelector(track.close.call(this));
    },
};
